module.exports = __webpack_public_path__ + "img/fr.9a5dcb2a.svg";